module.exports = __webpack_public_path__ + "94638e50294d543c73ee3faffd00f996.svg";


//////////////////
// WEBPACK FOOTER
// ./src/helpers/images/thankYouImage/background-green.svg
// module id = ./src/helpers/images/thankYouImage/background-green.svg
// module chunks = 4